// CommonCodeDict.js
// DbdbTap 2024-08-22 15:33:15
import { TableColumnType } from "../../value/AppConst";

export function addCommonCodeUniqueKey(list) {
    return list.map((item, index) => {
        return { ...item, codeGpAndId: item.codeGp + ':' + item.codeId };
    });
};
/**
 * COMMON_CODE React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-08-22 15:33:15 using DbdbTap
 */
export const CommonCodeDictionary = {
    errorTitle: {
        Add: '공통코드 생성 오류',
        Edit: '공통코드 수정 오류',
        Remove: '공통코드 삭제 오류',
        Get: '공통코드 조회 오류',
    },
    tableProps: {
        tableId: 'commonCodeTable',
        uniqueKey: 'codeGpAndId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'codeGp', label: '코드그룹', width: 160, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'codeId', label: '코드', width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'codeName', label: '코드명', width: 100, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            // { id: 'oldCodeId', label: '예전코드', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code1', label: '코드1', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code2', label: '코드2', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code3', label: '코드3', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code4', label: '코드4', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code5', label: '코드5', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code6', label: '코드6', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code7', label: '코드7', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code8', label: '코드8', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code9', label: '코드9', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'code10', label: '코드10', width: 40, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'flag1', label: 'Flag-1', width: 50, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'flag2', label: 'Flag-2', width: 50, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'content', label: '내용', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regDate', label: "등록일", width: 80, show: true, option:{align: 'inherit', print:(r,i,v)=>v?v.substring(0,10):''} },
            // { id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
